// Conocimiento de TIPOS de etapa — single source (nadie re-hardcodea tipos en
// componentes): icono, label i18n, qué es "cerrada" y el ORDEN canónico.
export const STAGE_TYPE_META = {
  incoming: {
    icon: 'i-lucide-inbox',
    labelKey: 'LEADS.STAGE_TYPES.INCOMING',
    closed: false,
  },
  open: {
    icon: 'i-lucide-columns-3',
    labelKey: 'LEADS.STAGE_TYPES.OPEN',
    closed: false,
  },
  won: {
    icon: 'i-lucide-trophy',
    labelKey: 'LEADS.STAGE_TYPES.WON',
    closed: true,
  },
  lost: {
    icon: 'i-lucide-x-circle',
    labelKey: 'LEADS.STAGE_TYPES.LOST',
    closed: true,
  },
};

export const isClosedType = type => !!STAGE_TYPE_META[type]?.closed;

export const stageTypeIcon = type => STAGE_TYPE_META[type]?.icon || '';

// Orden canónico del tablero: el embudo (incoming + open) por `position`; las
// cerradas SIEMPRE al final (won, luego lost) IGNORANDO su position. Corolario:
// reordenar columnas del embudo nunca puede corromper el orden relativo de las
// cerradas (que están ocultas por default y no participan del reorder).
export const orderStages = stages => {
  const funnel = stages.filter(s => !isClosedType(s.stage_type));
  const closed = ['won', 'lost']
    .map(type => stages.find(s => s.stage_type === type))
    .filter(Boolean);
  return [...funnel, ...closed];
};

// Grupos para los menús de mover / selectores de etapa: Embudo / Cierre.
export const groupedStages = stages => {
  const ordered = orderStages(stages);
  return {
    funnel: ordered.filter(s => !isClosedType(s.stage_type)),
    closed: ordered.filter(s => isClosedType(s.stage_type)),
  };
};
